import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { AuditLogService } from '../../../service/proxy'

@Injectable({ providedIn: 'root' })
export class LoginCallbackResolver implements Resolve<void> {
    //private auditLogService = inject(AuditLogService);

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
        // this.auditLogService.logSignIn()
        //     .subscribe({
        //         next: (result: any) => {
        //         },
        //         error: (error: any) => {
        //         }
        //     }
        // );
    }
}